class MobileLocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");

    this.form = this.querySelector("form");

    this.select.addEventListener("change", () => {
      this.form.submit();
    });
  }
}

if (!customElements.get("mobile-localization-form")) {
  customElements.define("mobile-localization-form", MobileLocalizationForm);
}
